import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  IconButton,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import {
  FileUpload as FileUploadIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

import { FileUploader } from "react-drag-drop-files";
import { useRef, useState } from "react";
import UserListSelector from "../../components/UserListSelector.jsx";
import { useSelector } from "react-redux";
import { uploadDocs } from "../../api/documents";
import useSnackbar from "../../hooks/useSnackbar";
import useCaseList from "../../hooks/useCaseList.js";
import { getCaseUsers } from "../../api/caseUsers.js";
import useErrorHandler from "../../hooks/useErrorHandler.js";
// import { allowedFileTypes, recentUploads } from '../../config/constants';
const allowedFileTypes = [
  "JPEG",
  "PNG",
  "PDF",
  "DOC",
  "DOCX",
  "XLS",
  "XLSX",
  "JPG",
];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export default function NewCaseDocuments() {
  const params = useParams();
  console.log("params---", params);
  const { data: user } = useSelector((state) => state.user);

  const { selectedCaseName, setSelectedCaseId } = useCaseList();
  setSelectedCaseId(params.caseId);

  const uploaderRef = useRef();
  const [files, setFiles] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [docUsers, setDocUsers] = useState([]);
  const [docText, setDocText] = useState("");
  const [selectedUserIndexes, setSelectedUserIndexes] = useState([]);
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedUserIndexes(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  useEffect(() => {
    if (!user.token || users.length) return;
    getCaseUsers(user.token, params.caseId).then(({ data }) => {
      const filteredData = data.data.filter((e) => e.user_id !== user.id);

      setUsers(filteredData);
    });
  }, [user.token]);
  const handleFileChange = (files) => {
    setFiles(files);
    setFileList(Object.keys(files).map((k) => files[k]));
    // uploadFile(file, controller, progressTracker).then().catch()
  };

  const onSubmit = async () => {
    if (fileList.length) {
      setLoader(true);
      try {
        let formData = new FormData();
        formData.append("text", docText);
        formData.append("users", docUsers.join(","));
        // formData.append('files', files);
        // console.log(formData);
        for (const key of Object.keys(files)) {
          formData.append("files", files[key]);
        }

        await uploadDocs(user.token, params.caseId, formData);
        snackbar.showSuccess("Document Uploaded.");
        setFileList([]);
        setDocUsers([]);
        setDocText("");
        setLoader(false);
        navigate(-1);
        navigate(-1);
        // navigate(`/documents/${params.caseId}`);
      } catch (error) {
        setLoader(false);
        errorHandler(error);
      }
    } else {
      snackbar.showSuccess("Please Select the document.");
    }
  };

  const removeFile = (idx) => {
    setFileList((prev) => prev.filter((p, i) => i !== idx));
  };
  useEffect(() => {
    // const ids = selectedUserIndexes.map(i => users[i].id);
    // console.log("selected indxs", selectedUserIndexes);
    // console.log("users", users);
    // setSelectedUsers(selectedUserIndexes.map(i => users[i]));
    collectData(selectedUserIndexes.map((i) => users[i]));
    // console.log(ids)
  }, [selectedUserIndexes]);
  function collectData(list) {
    setDocUsers(list.map((a) => a.user_id));
  }

  return (
    <Paper className="odr-upload-card">
      <Box p={3}>
        {/* <Box>
        Upload Document for Case <b>{selectedCaseName}</b>
      </Box>
      <br /> 
      <Box>*/}
        <Grid
          container
          rowSpacing={4}
          columnSpacing={2}
          justifyContent="center"
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box>
              {" "}
              Upload Document for Case <b>{selectedCaseName}</b>
            </Box>
          </Grid>
          <Grid item lg={12} md={12}>
            <Box display="flex" flexDirection="column" sx={{ rowGap: 3 }}>
              <TextField
                size="small"
                fullWidth
                placeholder="Enter details about the document(s)"
                value={docText}
                onChange={(e) => {
                  setDocText(e.target.value);
                }}
              />

              {/* <UserListSelector
                label="Doc Users"
                id={params.caseId}
                collectData={collectDocUsers}
                helperText="(visible to all case users if not specified)"
              /> */}
              <FormControl size="small" fullWidth>
                <InputLabel id="demo-multiple-checkbox-label">
                  {"Doc Users"}
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  fullWidth
                  value={selectedUserIndexes}
                  onChange={handleChange}
                  input={<OutlinedInput label={"Users"} fullWidth />}
                  renderValue={(selected) =>
                    selected.map((s) => users[s].name).join(", ")
                  }
                  MenuProps={MenuProps}
                >
                  {users.map((u, idx) => (
                    <MenuItem key={idx} value={idx}>
                      <Checkbox
                        checked={selectedUserIndexes.indexOf(idx) > -1}
                      />
                      <ListItemText primary={u.name} />
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {"(visible to all case users if not specified)"}
                </FormHelperText>
              </FormControl>
              <FileUploader
                multiple={true}
                handleChange={handleFileChange}
                name="case-docs"
                types={allowedFileTypes}
                fileOrFiles={files}
              >
                <Box
                  ref={uploaderRef}
                  py={4}
                  border="1px dashed #454545"
                  borderRadius={2}
                  display="flex"
                  alignItems="center"
                  columnGap={2}
                  justifyContent="center"
                >
                  <FileUploadIcon /> Drag and Drop file here
                </Box>
              </FileUploader>
              <Box display="flex" flexDirection="column" sx={{ rowGap: 2 }}>
                {Boolean(files) ? (
                  fileList.map((file, i) => (
                    <Box
                      key={i}
                      border="1px solid #D5DDD5"
                      borderRadius={1}
                      backgroundColor="#D8E9F0"
                      display="flex"
                      alignItems="center"
                    >
                      {/* <InsertDriveFileOutlined fontSize='small' /> */}
                      <Box px={1} pt={1} width="100%">
                        <Typography mb={1} fontSize="small">
                          {file?.name} ({formatFileSize(file?.size)})
                        </Typography>
                        {/* <LinearProgress variant="determinate" value={uploadProgess} /> */}
                      </Box>
                      <IconButton
                        color="error"
                        onClick={() => {
                          removeFile(i);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  ))
                ) : (
                  <></>
                )}
              </Box>
              {/* <Button
                variant="contained"
                sx={{ textTransform: "none", px: 4 }}
                color="primary"
                onClick={() => {
                  uploaderRef.current.click();
                }}
                size="large"
              >
                Select File
              </Button> */}
              {/* <br /> */}
              {loader === false ? (
                <Button
                  onClick={onSubmit}
                  variant="contained"
                  className="blue-button"
                  size="large"
                  disabled={/^trial_user$/i.test(user.roles) ? true : false}
                >
                  Submit
                </Button>
              ) : (
                <Box display="flex" alignItems="center" justifyContent="center">
                  <CircularProgress></CircularProgress>
                </Box>
              )}
            </Box>
          </Grid>
          {/* <Grid item lg={5} md={12}>
            <Box display="flex" flexDirection="column" sx={{ rowGap: 2 }}>
              {Boolean(files) ? (
                fileList.map((file, i) => (
                  <Box
                    key={i}
                    border="1px solid #D5DDD5"
                    borderRadius={1}
                    backgroundColor="#D8E9F0"
                    display="flex"
                    alignItems="center"
                  >
                    {/* <InsertDriveFileOutlined fontSize='small' /> */}
          {/* <Box px={1} pt={1} width="100%">
                      <Typography mb={1} fontSize="small">
                        {file?.name} ({formatFileSize(file?.size)})
                      </Typography>
                      {/* <LinearProgress variant="determinate" value={uploadProgess} /> */}
          {/*  </Box>
                    <IconButton
                      color="error"
                      onClick={() => {
                        removeFile(i);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                ))
              ) : (
                <></>
              )}
            </Box>
          </Grid> */}
          {/* <Grid item xl={9} lg={10} md={11}>
            <TextField size='small' fullWidth
              placeholder='Enter details about the document'
              value={docText}
              onChange={(e) => { setDocText(e.target.value) }}
            />
          </Grid> */}
          {/* <Grid item xl={9} lg={10} md={11}> */}
          {/* <FileUploader
              handleChange={handleFileChange}
              name="file"
              types={allowedFileTypes}
            >
              <Box ref={uploaderRef} py={4} border="1px dashed #454545" borderRadius={2}
                display="flex" alignItems="center" columnGap={2} justifyContent='center'
              >
                <FileUploadIcon /> Drag and Drop file here
              </Box>
            </FileUploader> */}
          {/* </Grid> */}
          {/* <Grid item textAlign='center' xl={9} lg={10} md={11}> */}
          {/* <Button variant='contained' sx={{ textTransform: "none", px: 4 }} color="primary"
              onClick={() => { uploaderRef.current.click() }}
            >
              Select File
            </Button> */}
          {/* </Grid> */}
          {/* <Grid item xl={9} lg={10} md={11}> */}

          {/* </Grid> */}
        </Grid>
      </Box>
    </Paper>
  );
}

// ************

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

// function UserList({ users = names, collectData }) {
//   // const [selectedUserIndexes, setSelectedUserIndexes] = useState([]);
//   const [selectedUserIds, setSelectedUserIds] = useState([]);
//   const [selectedUserIndexes, setSelectedUserIndexes] = useState([]);

//   const handleChange = (event) => {
//     const { target: { value } } = event;
//     setSelectedUserIndexes(
//       // On autofill we get a stringified value.
//       typeof value === 'string' ? value.split(',') : value,
//     );
//   };

//   useEffect(() => {
//     const ids = selectedUserIndexes.map(i => users[i].id);
//     collectData(ids)
//     // console.log(ids)
//   }, [selectedUserIndexes])

//   return (
//     <FormControl size='small' fullWidth >
//       <InputLabel id="demo-multiple-checkbox-label">Users</InputLabel>
//       <Select
//         labelId="demo-multiple-checkbox-label"
//         id="demo-multiple-checkbox"
//         multiple
//         fullWidth
//         value={selectedUserIndexes}
//         onChange={handleChange}
//         input={<OutlinedInput label="Users" fullWidth />}
//         renderValue={(selected) => selected.map(s => users[s].name).join(', ')}
//         MenuProps={MenuProps}
//       >
//         {users.map((u, idx) => (
//           <MenuItem key={idx} value={idx}>
//             <Checkbox checked={selectedUserIndexes.indexOf(idx) > -1} />
//             <ListItemText primary={u.name} />
//           </MenuItem>
//         ))}
//       </Select>
//       <FormHelperText>(visible to all case users if not specified)</FormHelperText>
//     </FormControl>
//   );
// }

/// utility

let k = 1000;
let sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

function formatFileSize(bytes = 0, dm = 2) {
  if (bytes == 0) return "0 Bytes";
  let i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
